import { Component, ContentChild, Input, OnInit, ViewChild } from '@angular/core';
import { EventTransportService } from '../../services/event-transport/event-transport.service';

@Component({
    selector: 'app-share',
    templateUrl: './share.component.html',
    styleUrls: ['./share.component.scss']
})
export class ShareComponent
{
    @Input() value: string = ''; 

    public shareValue(_event)
    {    
        navigator.share({
        title: 'Address',
        text: this.value,
        })
    }

}
